// extracted by mini-css-extract-plugin
module.exports = {"card":"Scroll_card__9jVil"};